(function () {
    "use strict";

    angular.module("app").controller("SearchDossierController", SearchDossierController);

    SearchDossierController.$inject = ["$scope", "infiniteScrollDataSourceFactory", "controllerDecorator", "userFunctions", "enumService"];
    function SearchDossierController($scope, infiniteScrollDataSourceFactory, controllerDecorator, userFunctions, enumService) {
        const vm = this;
        controllerDecorator.Decorate(vm, ["navigation"]);

        const screeningServices = enumService.ScreeningServices;
        
        // Public members

        vm.SetLoadingState(false);
        
        initialize();

        // Implementation

        function initialize() {
            $scope.DataSource = infiniteScrollDataSourceFactory.Create(vm.Api.SearchDossierPaged, (v) => vm.isLoadingRequests = v);

            let filter = $scope.DataSource.GetFilter();

            filter.DossierType = userFunctions.userWorksForPartner(screeningServices.FODECO) ? "O" : "P";

            const pageAndSort = $scope.DataSource.GetPageAndSort();
            if (pageAndSort.SortBy.length > 0) {
                $scope.sortType = pageAndSort.SortBy[0].Name;
                $scope.sortReverse = pageAndSort.SortBy[0].IsReverse;
            }
            else {
                $scope.sortType = "DossierNbr";
                $scope.sortReverse = false;
            }
        }
    }
})();
